module.exports = __webpack_public_path__ + "img/t1-duo-1.eb8ee972.png";